export default "__VITE_ASSET__DPIJwwlb__"